export default __webpack_public_path__ + "static/chart-b63758f8bb9a9088445fd4f73377d9ac.svg";